export const ACTIONS = {
  BILLING_CUSTOMER: 1,
  INVOICING_CUSTOMER: 2,
  CREATOR_REMARK: 3,
  OPERATION_REMARK: 4,
  PLANT_CHANGE: 5,
  OTHER_REQUEST: 6,
  VEHICLE_CHANGES: 7,
  REQUEST_ARRIVAL_TIME: 8,
  DELIVERY_CUTOFF_DATE: 9,
  KM_CHANGE: 10,
};
